module.exports = __webpack_public_path__ + "static/tat-37-f19f7a535cfa94943d8ab79f5efeb426.jpg";